import i18next from 'i18next';
import { LOCALE_COOKIE_EXPIRY, LOCALE_COOKIE_NAME } from './locales';
export function setLocale(lang, io) {
    if (lang === i18next.language) {
        return;
    }
    io.cookies.setCookie(LOCALE_COOKIE_NAME, lang, {
        expires: LOCALE_COOKIE_EXPIRY
    });
    io.locationReload();
}
